module.exports = __webpack_public_path__ + "c06180b7c874f62b6a3fa93fb1f8cfc7.png";